import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'cvc-form-buttons',
    templateUrl: './form-buttons.component.html',
    styleUrls: ['./form-buttons.component.less'],
    standalone: false
})
export class CvcFormButtonsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
